// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Domains',
  subtitle: 'Manage all domain records',
  addNew: 'New Domain',
  edit: 'Edit',
  delete: 'Delete',
  searchPlaceholder: 'Search domain, customer or registrar...',
  filterAll: 'All',
  filterActive: 'Active',
  filterInactive: 'Inactive',
  resultsFound: 'domains found',
  noDomains: 'No domains yet',
  noDomainsFiltered: 'No search results found',
  noDomainsDesc: 'Try different search terms',
  noDomainsStart: 'Start by adding your first domain.',
  tableDomain: 'Domain',
  tableCompany: 'Company',
  tableRegistrar: 'Registrar',
  tableServer: 'Server',
  tableStatus: 'Status',
  tableExpiry: 'Expiry',
  tableNs: 'NS',
  tableMonitoring: 'Monitoring',
  tableActions: 'Actions',
  statusActive: 'Active',
  statusInactive: 'Inactive',
  statusOnline: 'Online',
  statusOffline: 'Offline',
  domainOwnerOurs: 'Ours',
  domainOwnerCustomer: 'Theirs',
  expired: 'Expired',
  expiredDaysAgo: 'days ago',
  todayLastDay: 'Today is the last day',
  daysLeft: 'days left',
  lastCheck: 'Last check',
  monitoringActive: 'Website monitoring active',
  monitoringPassive: 'Website monitoring passive',
  viewDetails: 'View Details',
  deleteConfirm: 'Are you sure you want to delete this domain?',
  domainAdded: 'Domain successfully added',
  domainUpdated: 'Domain successfully updated',
  domainDeleted: 'Domain successfully deleted',
  fetchError: 'Data could not be retrieved',
  addError: 'Domain could not be added',
  updateError: 'Domain could not be updated',
  deleteError: 'Domain could not be deleted',
  monitoringToggleError: 'Website monitoring status could not be updated',
  whoisTitle: 'Data from WHOIS',
  whoisRegistrationDate: 'Registration Date',
  whoisExpiryDate: 'Expiry Date',
  whoisStatus: 'Status',
  whoisNs1: 'NS1',
  whoisNs2: 'NS2',
  whoisRegistrar: 'Registrar',
  whoisClose: 'Close',
  whoisEnterDomain: 'Please enter the domain name first',
  whoisQuerying: 'Querying WHOIS information...',
  whoisSuccess: 'WHOIS information successfully retrieved',
  whoisParseError: 'WHOIS data could not be parsed.',
  whoisFetchError: 'WHOIS information could not be retrieved',
  domainList: 'Domain List',
  tabAll: 'All',
  tabByCustomer: 'By Customer',
  tabByCompany: 'By Company',
  formTitle: 'Add New Domain',
  formEditTitle: 'Edit Domain',
  domainName: 'Domain Name',
  domainNamePlaceholder: 'example.com',
  company: 'Company',
  selectCompany: 'Select Company',
  companyLoading: 'Loading...',
  companyNotFound: 'No company found',
  registrar: 'Registrar',
  selectRegistrar: 'Select Registrar',
  server: 'Server',
  selectServer: 'Select Server',
  status: 'Status',
  domainOwner: 'Domain Owner',
  registrationDate: 'Registration Date',
  expiryDate: 'Expiry Date',
  formRegistrar: 'Registrar',
  whoisRegistrarPlaceholder: 'Auto-filled from WHOIS',
  ns1: 'NS1',
  ns1Placeholder: 'ns1.example.com',
  ns2: 'NS2',
  ns2Placeholder: 'ns2.example.com',
  notes: 'Notes',
  notesPlaceholder: 'Additional notes...',
  cancelButton: 'Cancel',
  addButton: 'Add',
  updateButton: 'Update',
  exportButton: 'Export',
  exportSuccess: 'Domains exported successfully',
  unassignedCustomer: 'Unassigned Customer',
  unassignedCompany: 'Unassigned Company',
  domains: 'domains',
  updating: 'Updating',
  bulkWhoisUpdate: 'Bulk WHOIS Update',
  domainsUpdated: '{{current}}/{{total}} domains updated',
  bulkUpdateNoDomains: 'No domains to update',
  bulkUpdateSkippedDomains: 'domains skipped (.at domains)',
  bulkUpdateSkippedInactive: 'inactive domains skipped',
  bulkUpdateSuccess: 'domains successfully updated',
  bulkUpdateSkipped: 'domains skipped',
  bulkUpdateError: 'Bulk update error',
  noSearchResults: 'No search results found',
  tryDifferentSearch: 'Try a different search term',
  addFirstDomain: 'Start by adding your first domain',
  whoisButton: 'WHOIS',
  activate: 'Activate',
  deactivate: 'Deactivate',
  domainActivated: 'Domain activated',
  domainDeactivated: 'Domain deactivated',
  statusToggleError: 'Domain status could not be updated',
  deactivateConfirmTitle: 'Deactivate Domain',
  deactivateConfirmMessage: 'Are you sure you want to deactivate this domain?',
  deactivateAlsoRelated: 'Also deactivate related domains',
  deactivateOnlyThis: 'Only deactivate this domain',
  relatedDomainsDeactivated: '{{count}} related domains also deactivated',
  noRelatedDomains: 'No related domains found'
};
